import React from "react";
import { Dialog, DialogTitle, DialogActions, DialogContent, Button, Box, Typography, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import PublishIcon from "@material-ui/icons/Publish";
import GetAppIcon from "@material-ui/icons/GetApp";

const useStyles = makeStyles(theme => ({
  dialogPaper: { borderRadius: 12 },
  optionBtn: {
    borderRadius: 8,
    padding: "14px 16px",
    justifyContent: "flex-start",
    textAlign: "left",
    textTransform: "none",
  },
  optionLabel: { display: "flex", flexDirection: "column", alignItems: "flex-start", marginLeft: 8 },
  optionTitle: { fontWeight: 700, fontSize: "0.95rem" },
  optionDesc: { fontSize: "0.75rem", opacity: 0.85 },
  stack: { display: "flex", flexDirection: "column", gap: 10, marginTop: 4 },
}));

/**
 * Ponto de entrada único do botão "Criar Card": escolher entre criar um
 * card individual, importar vários de uma vez a partir do template Excel,
 * ou baixar esse template pré-preenchido com os contatos já cadastrados.
 */
const CrmCardChoiceModal = ({ open, onClose, onChooseSingle, onChooseImport, onChooseExport }) => {
  const classes = useStyles();

  const choose = (fn) => {
    onClose();
    fn && fn();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth classes={{ paper: classes.dialogPaper }}>
      <DialogTitle>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Criar Card</span>
          <IconButton size="small" onClick={onClose}><CloseIcon /></IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box className={classes.stack}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.optionBtn}
            startIcon={<AddIcon />}
            onClick={() => choose(onChooseSingle)}
          >
            <span className={classes.optionLabel}>
              <Typography className={classes.optionTitle}>Criar Card Único</Typography>
              <Typography className={classes.optionDesc}>Escolher um contato e preencher os dados na hora</Typography>
            </span>
          </Button>

          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.optionBtn}
            startIcon={<PublishIcon />}
            onClick={() => choose(onChooseImport)}
          >
            <span className={classes.optionLabel}>
              <Typography className={classes.optionTitle}>Importar Cards em Massa</Typography>
              <Typography className={classes.optionDesc}>Subir a planilha exportada e preenchida</Typography>
            </span>
          </Button>

          <Button
            fullWidth
            variant="outlined"
            color="primary"
            className={classes.optionBtn}
            startIcon={<GetAppIcon />}
            onClick={() => choose(onChooseExport)}
          >
            <span className={classes.optionLabel}>
              <Typography className={classes.optionTitle}>Exportar Template</Typography>
              <Typography className={classes.optionDesc}>Baixar a planilha com os contatos já cadastrados</Typography>
            </span>
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CrmCardChoiceModal;
